import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";

const PaymentStatus = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const domainname = window.location.hostname;
  const userAddress = JSON.parse(localStorage.getItem("address"));
  const userProductData = JSON.parse(localStorage.getItem("slectedData"));
  const totalPrice = localStorage.getItem("totalPrice");

  const createOrder = async (transitionId, amount) => {
    try {
      const orderData = {
        orderId,
        products: userProductData,
        address: userAddress,
        transitionId,
        amount,
        domainname,
      };
      // log
      const res = await axios.post(
        `${process.env.REACT_APP_PHONEPE_NODE_URL}/api/order`,
        orderData
      );

      if (res.status === 201 || res.status === 200) {
        navigate(`/thankyou?txnId=${orderId}`);
      } else {
        navigate("/cart");
      }
    } catch (error) {
      console.error("Order creation failed:", error);
      navigate("/cart");
    }
  };

  useEffect(() => {
    const verifyPayment = async () => {
      if (!orderId) return;

      const PAYMENT_TYPE = process.env.REACT_APP_PAYMENT_TYPE;
      const BASE_URL = process.env.REACT_APP_PHONEPE_NODE_URL;

      try {
        if (PAYMENT_TYPE === "phonepe") {
          const res = await axios.get(
            `${BASE_URL}/api/phonepay/sdk/order-status/${orderId}`
          );
          const data = res?.data;

          if (data?.state === "COMPLETED") {
            const transitionId =
              data?.paymentDetails?.[0]?.transactionId || null;
            const amount = data?.amount / 100 || 0
            await createOrder(transitionId, amount);
          } else {
            navigate("/cart");
          }
        } else if (PAYMENT_TYPE === "indianpay") {
          const res = await axios.get(
            `${BASE_URL}/api/pay/order-status/${orderId}`
          );
          const data = res?.data;

          if (data?.status === "success") {
            const transitionId = data?.transactionid || null;
            await createOrder(transitionId, data?.amount || 0);
          } else {
            navigate("/cart");
          }
        } else if (PAYMENT_TYPE === "cashfree") {
          const orderDetails = {
            orderId,
            products: userProductData,
            address: userAddress,
            domainname,
          };
          const res = await axios.post(
            `${BASE_URL}/api/cashfree/verify-payment`,
            {
              orderId,
              appId: process.env.REACT_APP_CASHFREE_APP_ID,
              secretKey: process.env.REACT_APP_CASHFREE_SECRET_KEY,
              orderDetails,
            }
          );

          const data = res?.data;

          if (data?.status === "SUCCESS") {
            navigate(`/thankyou?txnId=${orderId}`);
            // const transitionId = data?.orderId || null;
            // await createOrder(transitionId, totalPrice || 0);
          } else {
            navigate("/cart");
          }
        } else if (PAYMENT_TYPE === "payu") {
          const res = await axios.post(`${BASE_URL}/api/payu/verify-payment`, {
            orderId,
          });

          const transactionDetails = res?.data?.transaction_details;
          const transaction =
            transactionDetails && Object.values(transactionDetails)[0];

          if (transaction?.status === "success") {
            const transitionId = transaction?.mihpayid || null;
            await createOrder(transitionId, totalPrice || 0);
          } else {
            navigate("/cart");
          }
        } else if (PAYMENT_TYPE === "razorpay") {

          const razorpay_order_id = searchParams.get("razorpay_order_id");
          const razorpay_payment_id = searchParams.get("razorpay_payment_id");
          const razorpay_signature = searchParams.get("razorpay_signature");
          const razorpay_secret = searchParams.get("razorpay_secret");

          if (!razorpay_order_id || !razorpay_payment_id || !razorpay_signature || !razorpay_secret) {
            console.warn("Missing Razorpay params, redirecting to cart...");
            navigate("/cart");
            return;
          }

          const res = await axios.post(`${BASE_URL}/api/razorpay/verify-payment`, {
            razorpay_order_id,
            razorpay_payment_id,
            razorpay_signature,
            razorpay_secret,

          });

          const data = res?.data;

          if (data?.success) {
            const transitionId = razorpay_payment_id || null;
            await createOrder(transitionId, totalPrice || 0);
          } else {
            navigate("/cart");
          }
        }
        else if (PAYMENT_TYPE === "paytm") {
          const response = await axios.post(
            `${BASE_URL}/api/paytm/verify-order`,
            {
              orderId,
              paytmmid: process.env.REACT_APP_PAYTM_MID,
              paytmkey: process.env.REACT_APP_PAYTM_KEY,
            }
          );

          if (response?.data?.data?.resultInfo?.resultStatus === "TXN_SUCCESS") {
            const transitionId = response?.data?.data?.txnId || null;
            await createOrder(transitionId, totalPrice || 0);
          } else {
            navigate("/cart");
          }
        }
      } catch (error) {
        console.error("Payment verification error:", error);
        navigate("/cart");
      }
    };
    verifyPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, navigate]);

  return <Spinner />;
};

export default PaymentStatus;
